export const generateError = (x: never): never => {
    throw new Error('Variant is not never' + x);
};
export const generateError2 = (): never => {
    throw new Error('Variant is not never');
};
